(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/shared-components/error-panel.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/shared-components/error-panel.js');
'use strict';

const Icon = svs.ui.ReactIcon;
const ErrorPanel = () => React.createElement("div", {
  className: "margin-top-2 align-center"
}, React.createElement("div", {
  className: "align-center margin-bottom-1"
}, React.createElement(Icon, {
  color: "fc-red",
  icon: "help-2",
  size: "700"
})), React.createElement("p", null, "Just nu har vi tekniska problem med denna ins\xE4ttningsmetod. Anv\xE4nd g\xE4rna n\xE5gon av v\xE5ra andra ins\xE4ttningsmetoder eller pr\xF6va igen senare."));
svs.accountservicesReact.deposit.swedbankExpress.sharedComponents.ErrorPanel = ErrorPanel;

 })(window);